import { lazy } from 'react';

const AddCustomQuestionsModal = lazy(
  () => import('modules/ExperienceTracking/modals/AddCustomQuestionsModal'),
);
const CompletionModal = lazy(
  () => import('modules/ExperienceTracking/modals/CompletionModal'),
);
const ExperienceTrackingExportModal = lazy(
  () =>
    import('modules/ExperienceTracking/modals/ExperienceTrackingExportModal'),
);
const ManageFieldsModal = lazy(
  () =>
    import(
      'modules/ExperienceTracking/pages/StaffExperienceTrackingPage/components/ManageRequirementsForm/components/ManageFieldsModal'
    ),
);
const ExperienceTypeInfoModal = lazy(
  () => import('./modals/ExperienceTypeInfoModal'),
);
const UpdateOrCreateSessionModal = lazy(
  () => import('./modals/UpdateOrCreateSessionModal'),
);
const SupervisorReviewEntryModal = lazy(
  () => import('modules/ExperienceTracking/modals/SupervisorReviewEntryModal'),
);
const ShareSupervisorVerificationModal = lazy(
  () =>
    import(
      'modules/ExperienceTracking/modals/ShareSupervisorVerificationModal/ShareSupervisorVerificationModal'
    ),
);
const XPTrackingByStudentGuideModal = lazy(
  () =>
    import('modules/ExperienceTracking/modals/XPTrackingByStudentGuideModal'),
);
const OhioIRCPointsOverviewModal = lazy(
  () => import('modules/ExperienceTracking/modals/OhioIRCPointsOverviewModal'),
);

export default {
  ADD_CUSTOM_QUESTIONS_MODAL: AddCustomQuestionsModal,
  EXPERIENCE_TRACKING_EXPORT_MODAL: ExperienceTrackingExportModal,
  EXPERIENCE_TYPE_INFO_MODAL: ExperienceTypeInfoModal,
  MANAGE_EXPERIENCE_TRACKING_FIELDS_MODAL: ManageFieldsModal,
  PORTFOLIO_COMPLETION_MODAL: CompletionModal,
  SUPERVISOR_REVIEW_ENTRY_MODAL: SupervisorReviewEntryModal,
  UPDATE_OR_CREATE_SESSION_MODAL: UpdateOrCreateSessionModal,
  SHARE_SUPERVISOR_VERIFICATION_LINK_MODAL: ShareSupervisorVerificationModal,
  XP_TRACKING_BY_STUDENT_GUIDE_MODAL: XPTrackingByStudentGuideModal,
  OHIO_IRC_POINTS_OVERVIEW_MODAL: OhioIRCPointsOverviewModal,
};
